import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";
import { ApplyInputTypeInfo, SubscribeInfoData } from "./agent-user-subinfo-get";

// 原始接口
export interface Response {
  templates: templates[];
};

export interface templates {
  id: number;
  name: string;
  provider: string;
  sample_url: string;
  description?: string;
  use_count: number;
  star_count: number;
  created_at: Date;
  voice_tts_id: string;
  age_group: string;
  emotion: string;
  gender: string;
  language: string;
  process_status: number;
  input_text: string;
  deleted_at?: string;
};

// 请求接口
export interface AgentUserAudioTemplatesFilterRequest {
  pageSize?: number;
  provider?: string;
  sid?: number;
  name?: string;
}

export class PublicAudioTemplateData {
  @Required("id cannot be empty")
  @IsNumber("id must be a number")
  id: number;

  @Required("name cannot be empty")
  @IsString("name must be a string")
  name: string;

  @Required("sampleUrl cannot be empty")
  @IsString("sampleUrl must be a string")
  sampleUrl: string;

  @Required("voiceTtsId cannot be empty")
  @IsString("voiceTtsId must be a string")
  voiceTtsId: string;

  @Required("gender cannot be empty")
  @IsString("gender must be a string")
  provider: string;

  // @Required("speedRatio cannot be empty")
  @IsNumber("speedRatio must be a number")
  speedRatio: number;
}

export class PaginationData {
  @IsNumber("total must be a number")
  total: number;

  @IsNumber("sid must be a number")
  sid: number;
}

export class AgentUserAudioTemplatesFilterData {
  @IsArray("templates must be an array")
  templates: PublicAudioTemplateData[];

  @ValidateNested(PaginationData)
  pagination: PaginationData;

  // @Required("sid cannot be empty")
  @IsNumber("sid must be a number")
  sid: number;
}

const transformAndValidateAgent = (
  response: Response
): AgentUserAudioTemplatesFilterData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentUserAudioTemplatesFilterData);
  } catch (error) {
    console.error("Agent data validation failed:", error.message);
    throw error;
  }
};

/** 公共音频模板 */
export const agentUserAudioTemplatesFilter = async ({
  pageSize,
  provider,
  sid,
  name,
}: AgentUserAudioTemplatesFilterRequest): Promise<AgentUserAudioTemplatesFilterData> => {
  const response = await api.post<Response>('/agent/user/audio-templates/filter', {
    page_size: pageSize,
    provider,
    sid,
    name,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
